var _a;
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var receivedBallotsSlice = createSlice({
    name: "receivedBallots",
    initialState: initialState,
    reducers: {
        setReceivedBallot: function (state, action) {
            state[action.payload.electionId] = action.payload.receivedBallot;
            return state;
        },
        clearReceivedBallot: function (state, action) {
            delete state[action.payload];
        },
    },
});
export var setReceivedBallot = (_a = receivedBallotsSlice.actions, _a.setReceivedBallot), clearReceivedBallot = _a.clearReceivedBallot;
export var selectReceivedBallot = function (electionId) { return function (state) {
    return state.receivedBallots[electionId];
}; };
// The Ballot ID the ballot box signed for this ballot, if it has received it.
export var selectReceivedBallotId = function (electionId, ballotHash) {
    return function (state) {
        var receivedBallot = state.receivedBallots[electionId];
        return receivedBallot && receivedBallot.ballot_hash === ballotHash
            ? receivedBallot.ballot_id
            : undefined;
    };
};
export default receivedBallotsSlice.reducer;
